import { useNavigate } from 'react-router-dom';

const Forbidden = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-gray-800">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-red-500">403</h1>
        <p className="text-2xl mt-4 font-semibold">
          Access Denied
        </p>
        <p className="text-md mt-2 text-gray-600">
          You don't have permission to access this page.
        </p>
        <div className="mt-6">
          <button
            onClick={handleGoBack}
            className="px-4 py-2 mr-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Go Back
          </button>
          <button
            onClick={handleGoHome}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
          >
            Go to Homepage
          </button>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
